<template>
  <div>
    <ViewLoadingMessage :loading="!loading"/>
    <div v-if="loading">
      <h1 class="main-header" v-translate>Marketing assets</h1>
        <MediaKit :media-kit="mediaKit"/>
    </div>
  </div>
</template>
<script>
import MediaKit from "@/domain/eventManage/components/MediaKit.vue";
import {mapActions, mapGetters} from "vuex";
import ViewLoadingMessage from "@/components/ViewLoadingMessage.vue";

export default {
  name: "MarketingAssets",
  components: {ViewLoadingMessage, MediaKit},
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters('eventWizard', [
      'mediaKit',
    ]),
  },
  async mounted() {
    await this.fetchMediaKit()
    this.loading = true
  },
  methods: {
    ...mapActions('eventWizard', [
      'fetchMediaKit',
    ]),
  }
}
</script>


<style scoped>

</style>